<div class="shadow-box flex flex-col items-center max-w-screen-sm">
    <!-- <img src="../../assets/img/login-penguin.webp" class="mt-12 mb-6 w-40 h-40 rounded-full"/> -->
    <h3>Passwort Zurücksetzen</h3>
        <div class="my-4 w-full">
            @if(!success){
                <form (ngSubmit)="onSubmit()" [formGroup]="resetPasswordForm">
                    <div class="my-4">
                        <label for="password" class="block text-sm font-medium leading-6">Neues Passwort</label>
                        <div class="mt-2">
                            <input id="password" formControlName="password"
                                class="block w-full rounded border border-grey py-1.5" type="password" required
                                placeholder="" [ngClass]="{
                                    'invalid': resetPasswordForm.get('password')?.invalid && (resetPasswordForm.get('password')?.touched)
                                  }">
                                  @if (resetPasswordForm.get('password')?.invalid &&
                                  (resetPasswordForm.get('password')?.touched)) {
                                  <div class="text-red text-sm mt-2">
                                      Passwort muss aus mindestens 8 Zeichen beinhalten
                                  </div>
                                  }
                        </div>
                    </div>
    
                    <div class="my-4">
                        <label for="passwordConfirm" class="block text-sm font-medium leading-6">Neues Passwort Wiederholen</label>
                        <div class="mt-2">
                            <input id="passwordConfirm" formControlName="passwordConfirm" name="passwordConfirm"
                                class="block w-full rounded border border-grey py-1.5" type="password" required
                                placeholder="" [ngClass]="{
                                    'invalid': resetPasswordForm.invalid && (resetPasswordForm.get('passwordConfirm')?.touched && resetPasswordForm.hasError('notSame'))
                                  }">
                                  @if (resetPasswordForm.invalid && (resetPasswordForm.get('passwordConfirm')?.touched &&
                                  resetPasswordForm.hasError('notSame'))) {
                                  <div class="text-red text-sm mt-2">
                                      Passwörter stimmen nicht überein
                                  </div>
                                  }
                        </div>
                    </div>
    
                    <div class="w-full flex flex-row justify-end items-center gap-4">
                        @if (resetPasswordForm.invalid) {
                        <button type="submit" disabled class="white-button disabled cursor-not-allowed !h-12">Passwort Festlegen</button>
                        } @else {
                        <button type="submit" class="blue-button !h-12">Passwort Festlegen</button>
                        }
                    </div>
                </form>
            } @else {
                <p>Dein Passwort wurde erfolgreich geändert! Du wirst in wenigen Sekunden zum Login weitergeleitet.</p>
            }
        </div>
</div>